module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/flower-1-d162a4273446a321ef34fd3f38d6b1f3.svg";